import { forwardRef } from "react";
import { Icon, type IconProps } from "../Icon";

export const Linkedin = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return (
    <Icon ref={ref} {...props}>
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6M2 9h4v12H2z" />
      <circle cx="4" cy="4" r="2" />
    </Icon>
  );
});

Linkedin.displayName = "Linkedin";
